/* unplugin-vue-components disabled */import { render } from "./ConfirmLogout.vue?vue&type=template&id=be20791e&ts=true"
import script from "./ConfirmLogout.vue?vue&type=script&lang=ts"
export * from "./ConfirmLogout.vue?vue&type=script&lang=ts"

import "./ConfirmLogout.vue?vue&type=style&index=0&id=be20791e&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__